export default function isNullOrWhitespace(input: string | undefined) {
    // if (input === undefined) return false;
    return !input || !input.trim();
}